module.exports = __webpack_public_path__ + "static/hero3-5dfb09ca97a7366b7372aa00289d2dc4.jpg";